var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('iframe',{ref:"iframe",staticClass:"iframe",attrs:{"name":"iframe1","src":_vm.url,"frameborder":"0","width":"350px","height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }